import React, { useState, useEffect } from 'react';
import HollowButton from 'Components/Button/HollowButton';
import PropTypes from 'prop-types';
import CheckIcon from 'Components/icons/check-icon/CheckIcon.jsx';
import AppNotification from 'Components/AppNotification/AppNotification.jsx';
import counterpart from "counterpart";
import './FilterPanel.scss';

const FilterPanel = (props) => {
  const [selectedBoxOne, setSelectionBoxOne] = useState('All');
  const [boxOneSelections, setBoxOneSelections] = useState([]);
  const [selectedBoxTwo, setSelectedBoxTwo] = useState(counterpart('globalTranslate.caseLanding.newestFirst'));
  const [selectedBoxThree, setSelectedBoxThree] = useState('Anyone');
  const [boxThreeSelections, setBoxThreeSelections] = useState([]);
  const [selectCaseFilter, setSelectedCaseFilter] = useState('Case Timeline');
  var selectList =[];

  const updateFilterSelection = () => {
    const allCount = props.sectionFilters.countDoc + props.sectionFilters.countMerchAdv + props.sectionFilters.countNotes  + props.sectionFilters.countFinancial + props.sectionFilters.countAction;
    let newBoxOne = [{name:'All',desc : '  CTRL+0',count:allCount}];

    if (props.sectionFilters.countDoc > 0) {newBoxOne = newBoxOne.concat(({name : counterpart('globalTranslate.caseLanding.documents') , desc : '  CTRL+3',count : props.sectionFilters.countDoc, }))}
	  if (props.sectionFilters.countMerchAdv> 0) {newBoxOne = newBoxOne.concat(({name : counterpart('globalTranslate.caseLanding.merchAdvice'),desc : '  CTRL+2',count : props.sectionFilters.countMerchAdv}))}
    if (props.sectionFilters.countNotes > 0) {newBoxOne = newBoxOne.concat(({name : 'Notes', desc : '  CTRL+5', count : props.sectionFilters.countNotes}))}
    if (props.sectionFilters.countFinancial> 0) {newBoxOne = newBoxOne.concat(({name : counterpart('globalTranslate.caseLanding.financials'), desc : '  CTRL+4', count : props.sectionFilters.countFinancial}))}
    if (props.sectionFilters.countAction > 0) {newBoxOne = newBoxOne.concat(({name : counterpart('globalTranslate.caseLanding.action'),desc : '  CTRL+1', count : props.sectionFilters.countAction}))}
    setBoxOneSelections(newBoxOne); 
  };

  const showCaseTimelineOrHistory = (select) => {
    setSelectedCaseFilter(select);
    props.showTimelineOrHistory(select);
  };
  
  const updateUserSelection = (toFilter) => {
    const availableFilters = toFilter.map((item) => {
      return item.eventBodyDetails.GeneratedByUser;
    });
    const cleanFilters = availableFilters.filter((item) => item !== undefined);
    const filterSet = ['Anyone', ...new Set(cleanFilters)];
    setBoxThreeSelections(filterSet);
  };
  useEffect(() => {
    if (props.data.length > 0) {
      updateFilterSelection();
      updateUserSelection(props.data);
    }
  }, [props.data]);

  useEffect(() => {
    !props.isMerchantUser && window.addEventListener('keydown', handleUserKeyPress);
    return () => {
      setSelectionBoxOne('All');
      setSelectedBoxTwo(counterpart('globalTranslate.caseLanding.newestFirst'));
      !props.isMerchantUser &&  window.removeEventListener('keydown', handleUserKeyPress);
    };
  }, [props.data]);

  const handleUserKeyPress = event => {
    const eventCode = event.code ? (event.code + "_" + event.ctrlKey) : event.key + "_" + event.ctrlKey;
    let tempFilterList = [];
    if (eventCode === "Digit0_true" && event.ctrlKey === true) {
      tempFilterList = ['All'];
    }
    else if (props.sectionFilters.countAction > 0 && eventCode === "Digit1_true" && event.ctrlKey === true) {
      const action = ['Action'];
      tempFilterList = tempFilterList.concat([...action]);
    }
    else  if (props.sectionFilters.countMerchAdv> 0 && eventCode === "Digit2_true" && event.ctrlKey === true) {
      const merchantAdvice = ['Merchant Advice'];
      tempFilterList = tempFilterList.concat([...merchantAdvice]);
    }
    else  if (props.sectionFilters.countDoc > 0 && eventCode === "Digit3_true" && event.ctrlKey === true) {
      const Documents = ['Documents'];
      tempFilterList = tempFilterList.concat([...Documents]);
    }
    else  if (props.sectionFilters.countFinancial> 0 && eventCode === "Digit4_true" && event.ctrlKey === true) {
      const Financials = ['Financials'];
      tempFilterList = tempFilterList.concat([...Financials]);
    }
    else  if (props.sectionFilters.countNotes > 0 && eventCode === "Digit5_true" && event.ctrlKey === true) {
      const Notes = ['Notes'];
      tempFilterList = tempFilterList.concat([...Notes]);
    }
    !props.isMerchantUser && tempFilterList.length > 0 && callFilterByType(tempFilterList);
  };

  // Hard-coded for now; lets pass these down dynamically in the future
  // so this component will be reusable going forward
  const caseSetOne = boxOneSelections;
  const caseSetThree = boxThreeSelections;

  const selectionDisplayFilterBox = {
    header: 'Display',
    values: ['Case Timeline', 'Case Events Log'],
  };
  const selectionBoxOne = {
    header: counterpart('globalTranslate.caseLanding.showInTimeline'),
    values: caseSetOne,
  };
  const selectionBoxTwo = {
    header: counterpart('globalTranslate.caseLanding.orderBy'),
    values: [counterpart('globalTranslate.caseLanding.newestFirst'), counterpart('globalTranslate.caseLanding.oldestFirst')],
  };
  const selectionBoxThree = {
    header: 'Created By',
    values: caseSetThree,
  };
  const callFilterByType = (select) => {
     selectList = selectList.concat(selectedBoxOne);
     selectList = selectList.includes('All') ? selectList.filter(e => e !== 'All') : selectList;
     selectList = selectList.includes(select) ? selectList.filter(e => e !== select) : selectList.concat(select)
     selectList = (select === 'All') ? selectList = ['All'] : selectList;
    props.filterByType(selectList, selectedBoxTwo, selectedBoxThree);
    setSelectionBoxOne(selectList);
  };
  const callFilterByParty = (select) => {
    props.filterByParty(select, selectedBoxOne, selectedBoxTwo);
    setSelectedBoxThree(select);
  };
  const sortByDate = (select) => {
    setSelectedBoxTwo(select);
    const value = select === counterpart('globalTranslate.caseLanding.newestFirst') ? 'compareDesc' : 'compareAsc';
    props.sortDataByTime(value);
  };
  // eslint-disable-next-line no-undef
  const renderBoxSelections = (item) => {
    const boxGroups = {
      One: {
        list: selectionBoxOne.values,
        selectedState: selectedBoxOne,
        action: callFilterByType,
      },
      Two: {
        list: selectionBoxTwo.values,
        selectedState: selectedBoxTwo,
        action: sortByDate,
      },
      Three: {
        list: selectionBoxThree.values,
        selectedState: selectedBoxThree,
        action: callFilterByParty,
      },
      Display: {
        list: selectionDisplayFilterBox.values,
        selectedState: selectCaseFilter,
        action: showCaseTimelineOrHistory,
      }
    };
    return (
      boxGroups[item].list.map((select) => {
        if (item == "One") {
	//This change is for white labeling for HPY
          const acquirerCode = JSON.parse(sessionStorage.getItem("state")).auth.user.acquirerCode == 'HPY' ? 
		JSON.parse(sessionStorage.getItem("state")).auth.user.acquirerCode : 'GPN';
          const isSelected = selectedBoxOne.includes(select.name)  ? 'filter-button is-selected' : 'filter-button';
          const isSelectedHPY = selectedBoxOne.includes(select.name)  ? 'filter-button is-selectedHPY' : 'filter-button';

          return (
            <HollowButton
              key={select.name}
              action={() => boxGroups[item].action(select.name)}
              disabled={false}
              extraClass={acquirerCode=="GPN"?`${isSelected}`:`${isSelectedHPY}`}
            > 
              {select.name}
              {!props.isMerchantUser &&  select.desc}
              <AppNotification
                className="app-notification-badge-filter-panel"
                info
                badgeType="info"
              >
                {select.count}
              </AppNotification>
              {selectedBoxOne.includes(select.name) && <CheckIcon stroke="#262aff" />}
            </HollowButton>
          );
        }
        else {
	//This change is for white labeling for HPY
           const acquirerCode = JSON.parse(sessionStorage.getItem("state")).auth.user.acquirerCode == 'HPY' ? 
		JSON.parse(sessionStorage.getItem("state")).auth.user.acquirerCode : 'GPN';
          const isSelectedHPY = boxGroups[item].selectedState === select ? 'filter-button is-selectedHPY' : 'filter-button';
          const isSelected = boxGroups[item].selectedState === select ? 'filter-button is-selected' : 'filter-button';
          return (
            <HollowButton
              key={select}
              action={() => boxGroups[item].action(select)}
              disabled={false}
              extraClass={acquirerCode=="GPN"?`${isSelected}`:`${isSelectedHPY}`}
            >
              {select}
              {boxGroups[item].selectedState === select && <CheckIcon stroke="#262aff" />}
            </HollowButton>
          );
        }
      })
    );
  };
  //This change is for white labeling for HPY
   const acquirerCode = JSON.parse(sessionStorage.getItem("state")).auth.user.acquirerCode == 'HPY' ? 
		JSON.parse(sessionStorage.getItem("state")).auth.user.acquirerCode : 'GPN';
  return (
    <div className="selection-box-container">
      {!props.isMerchantUser && selectionDisplayFilterBox.values.length > 1 && !props.isCaseFailedToLoad
        && (
          <div className="selection-box">
            <span className={"timeline-header "+acquirerCode}>{selectionDisplayFilterBox.header}</span>
            {renderBoxSelections('Display')}
          </div>
        )
      }
      {props.showCaseTimelineFlag !== 'Case Events Log' && selectionBoxOne.values.length > 1 && !props.isCaseFailedToLoad
        && (
          <div className="selection-box">
            <span className={"timeline-header "+acquirerCode}>{selectionBoxOne.header}</span>
            {renderBoxSelections('One')}
          </div>
        )
      }
      {props.showCaseTimelineFlag !== 'Case Events Log' &&  selectionBoxTwo.values.length > 1 && selectionBoxOne.values.length > 1 && !props.isCaseFailedToLoad
        && (
          <div className="selection-box">
            <span className={"timeline-header "+acquirerCode}>{selectionBoxTwo.header}</span>
            {renderBoxSelections('Two')}
          </div>
        )
      }
      {props.showCaseTimelineFlag !== 'Case Events Log' && selectionBoxThree.values.length > 1 && !props.isCaseFailedToLoad
        && (
          <div className="selection-box">
            <span className={"timeline-header "+acquirerCode}>{selectionBoxThree.header}</span>
            {renderBoxSelections('Three')}
          </div>
        )
      }
    </div>
  );
};

FilterPanel.propTypes = {
  data: PropTypes.array,
  sortDataByTime: PropTypes.func.isRequired,
  filterByType: PropTypes.func,
  filterByParty: PropTypes.func,
};

FilterPanel.defaultProps = {
  data: [],
  filterByType: () => {},
  filterByParty: () => {},
};

export default FilterPanel;
